import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { Currency } from '@/lib/supabase/types'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const CURRENCY_SYMBOLS: Record<Currency, string> = {
  EUR: "€",
  USD: "$",
  GBP: "£",
  MXN: "$",
  ARS: "$",
  COP: "$",
  CLP: "$",
  PEN: "S/",
}

export function formatCurrency(
  amount: number,
  currency: Currency = "EUR",
  position: "before" | "after" = "before",
): string {
  const symbol = CURRENCY_SYMBOLS[currency] || "€"
  const formatted = amount.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  return position === "after" ? `${formatted} ${symbol}` : `${symbol}${formatted}`
}
